import SortByField from './SortByField';

export const PARAM_SORTBY = 'sortby';
export const PARAM_SORTBY_ORDER = 'sortbyorder';

export default SortByField;
